module.exports = __webpack_public_path__ + "media/entities/1609-3fccb579.png";